import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { approveVolunteersBulkActionType, } from '../schemas/approveVolunteersSchema';
import { canApproveVolunteers, filterApprovedShiftParticipantsByPositionIds, getShiftStorage } from '../utils';
import { approveVolunteersInternal } from '../utils/approveVolunteersInternal';
export const approveVolunteersBulkAction = defineBulkAction({
    type: approveVolunteersBulkActionType,
    onAuthRunSync: () => true,
    onAuthBulkAction: (context, { data }) => {
        const shift = getShiftStorage(context).get(data.params.shiftId);
        canApproveVolunteers(context, data.params, shift);
        return { secureFilter: filterApprovedShiftParticipantsByPositionIds(data.params) };
    },
    onProcessBulkAction: (context, { data, updateProcessedCount, updateTotalCount }) => {
        const shift = getShiftStorage(context).get(data.params.shiftId);
        updateTotalCount(data.params.totalShiftParticipations);
        approveVolunteersInternal(context, {
            data: data.params,
            filter: data.secureParams.secureFilter,
            allowDeniedNotQualified: true,
            updateProcessedCount: updateProcessedCount,
            shift: shift,
        });
    },
});
